import { LinkedBillingMode, billingModeAt } from './linkedBillingMode';
import { fetchLinkConfigs } from './projectLinkService';

/**
 * Die Abrechnungsart mehrerer Toechter — aufgeloest auf EINEN Tag.
 *
 * Gebraucht auf der MUTTER-Seite: dort steht im Protokoll die Buchung einer
 * Tochter, aber nicht deren Abrechnungsart. Ohne sie kann die Mutter nicht
 * entscheiden, ob die Buchung ihre eigene Begehung sperrt.
 *
 * Gelesen werden die Spalten aus Nr. 71 (`linked_billing_mode`,
 * `linked_billing_history`), nicht mehr der JSON-Pfad im Blob — der ist seit
 * dem Vorfall 6290 nicht mehr die Wahrheit. Faellt die Abfrage aus, bleibt die
 * Karte leer — der Aufrufer sperrt dann im Zweifel, und das ist die richtige
 * Richtung: der Riegel ist weich und im Dialog ueberstimmbar.
 */
export const fetchChildBillingModes = async (
    childIds: string[],
    tag?: string | null,
): Promise<Map<string, LinkedBillingMode | undefined>> => {
    const modi = new Map<string, LinkedBillingMode | undefined>();
    const ids = [...new Set((childIds || []).filter(Boolean))];
    if (ids.length === 0) return modi;
    try {
        const configs = await fetchLinkConfigs(ids);
        for (const [id, cfg] of configs) modi.set(id, billingModeAt(cfg, tag));
        return modi;
    } catch (e) {
        console.warn('Abrechnungsart der Tochterprojekte nicht lesbar — es wird im Zweifel gesperrt:', e);
        return new Map();
    }
};
